<template>
  <a class="svg-holder body-appear" href="/" @click.prevent="themeChange" @keydown.enter.prevent="themeChange">
    <div class="circle sun" :class="{'pulse':!hasBeenClicked}"></div>
    <div class="circle moon"></div>
  </a>
</template>
<script>
import { eventBus } from "../../main";
export default {
  data() {
    return {
      hasBeenClicked: null
    };
  },
  methods: {
    themeChange() {
      this.hasBeenClicked = true;
      window.localStorage.setItem("hasBeenClicked", true);
      eventBus.$emit("swapTheme");
    }
  },
  created() {
    window.localStorage.getItem("hasBeenClicked");
    this.hasBeenClicked = window.localStorage.getItem("hasBeenClicked");
  }
};
</script>